// Модель стоп-листа для экрана: одно блюдо на нескольких кассах — одна строка, подпись касс.

// «1 Этаж», «2 Этаж» → «1 и 2 этаж»; разные названия — через запятую и «и»
export function terminalsLabel(names) {
  if (names.length <= 1) return names[0] || '';
  const parts = names.map((name) => name.trim().match(/^(\S+)\s+(.+)$/));
  const tail = parts.every(Boolean) && parts.every((p) => p[2].toLowerCase() === parts[0][2].toLowerCase());
  const heads = tail ? parts.map((p) => p[1]) : names;
  const joined = `${heads.slice(0, -1).join(', ')} и ${heads[heads.length - 1]}`;
  return tail ? `${joined} ${parts[0][2].toLowerCase()}` : joined;
}

// Позиции одного блюда на разных кассах — одна строка. «С какого времени» и «сколько» — самый ранний стоп;
// «свежесть» — по самому позднему (новое событие на одном этаже не прячется в «Давно»). Статус «В стопе», если
// остатка нет хоть на одной кассе, иначе «Осталось» — наименьший остаток
export function mergeByDish(items) {
  const dishes = new Map();
  for (const item of items) {
    const dish = dishes.get(item.product_id);
    if (!dish) {
      dishes.set(item.product_id, { ...item, terminals: [item.terminal_group].filter(Boolean), newestMinutes: item.minutes });
      continue;
    }
    if (item.terminal_group && !dish.terminals.includes(item.terminal_group)) dish.terminals.push(item.terminal_group);
    if (item.added && (!dish.added || item.added < dish.added)) {
      dish.added = item.added;
      dish.minutes = item.minutes;
    }
    if (item.minutes != null && (dish.newestMinutes == null || item.minutes < dish.newestMinutes)) dish.newestMinutes = item.minutes;
    if (item.status === 'stop' || dish.status === 'stop') {
      dish.status = 'stop';
      dish.balance = 0;
    } else {
      dish.balance = Math.min(dish.balance, item.balance);
    }
  }
  return [...dishes.values()].map((dish) => ({ ...dish, terminals: [...dish.terminals].sort() }));
}
